import { invalidateCache } from 'api/urql/helpers/mutation';

export const markPaymentMethodAsDefault = (results, args, cache, info) => {
  invalidateCache('requestor')(results, args, cache, info);
};
